import { floorPlanItems } from 'data/mock-data';

const mock = () => ({
  data: { floorPlanItems: floorPlanItems },
});

export default mock;
